package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class ErrorResponse(
  val error: Error
) {
  @Serializable
  data class Error(
    val id: String,
    val type: Type,
    val code: String,
    val title: String?,
    val details: String?
  ) {
    enum class Type {
      Validation,
      Conflict,
      NotFound,
      Failure,
      Unexpected,
      Unauthorized,
      Forbidden,
      Spam,
      Unsupported
    }
  }
}
